import React from 'react';
import Bugsnag, { BreadcrumbType } from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

import { APP_VERSION } from '../constants';

import { getUser } from './helperMethods';

const BugSnagTypes = { STATE: 'state', ERROR: 'error' };

export const bugSnagInititalize = () => {
  const isEnabledReleaseStage = Boolean(
    import.meta.env.VITE_REACT_APP_BUG_SNAG_IS_ENABLED_RELEASE_STAGE,
  );
  const enabledReleaseStages = isEnabledReleaseStage
    ? [import.meta.env.VITE_REACT_APP_ENV]
    : [];

  Bugsnag.start({
    apiKey: isEnabledReleaseStage
      ? import.meta.env.VITE_REACT_APP_BUG_SNAG_API_KEY
      : 'noAPIKeyNeeded',
    plugins: [new BugsnagPluginReact()],
    onError: (event) => {
      const user = getUser();
      event.setUser(user.id, user.email || "Guest", user.full_name || "Guest user");
      const errorClass = event?.errors[0]?.errorClass;
      const errorMessage = event?.errors[0]?.errorMessage;
      const originalError = event?.originalError;

      if (originalError) {
        // Check if the stack trace contains googleapis.com/maps/api
        if (originalError.stack && originalError.stack.includes("googleapis.com/maps/api")) {
          console.warn("Google Maps API error ignored:", originalError.stack);
          return false; // Prevent Bugsnag from reporting this error
        }
      }
      // Check for the chunk error class or message
      if (
        errorClass === 'ChunkLoadError' ||
        errorMessage?.includes('Loading CSS chunk') ||
        errorMessage?.includes("Failed to load Stripe.js") ||
        errorMessage.includes(".scrollHeight") ||
        errorMessage?.includes("Could not load \"util\"") ||
        errorMessage?.includes("Unable to preload CSS") ||
        errorMessage?.includes("ResizeObserver loop") ||
        errorMessage?.includes("Unexpected token") ||
        errorMessage?.includes("Failed to fetch") ||
        errorMessage?.includes("Failed to fetch dynamically") ||
        errorMessage?.includes("unhandledrejection handler") ||
        errorMessage?.includes("Importing a module script failed.") ||
        errorMessage?.includes("Network Error") ||
        errorMessage?.includes("Request aborted") ||
        errorMessage?.includes("Failed to execute 'query' on 'Permissions'") ||
        errorMessage?.includes("Converting circular structure to JSON")
      ) {
        return false; // Prevent Bugsnag from reporting this error
      }

      if (errorMessage?.includes('Request failed with status code 400')) {
        Bugsnag.notify(errorMessage),
          (bugsnagEvent) => {
            bugsnagEvent.addMetadata("meta-data", {
              reason: JSON.stringify(event),
              type: typeof event
            });
          }
      }

      // if (
      //   errorMessage?.includes("Failed to fetch dynamically") ||
      //   errorMessage?.includes("unhandledrejection handler") ||
      //   errorMessage?.includes("Importing a module script failed.") ||
      //   errorMessage?.includes("Request failed with status code 400")
      // ) {
      //   Bugsnag.notify(new Error(`Error occurred due to ${errorMessage}`),
      //     (bugsnagEvent) => {
      //       bugsnagEvent.addMetadata("meta-data", {
      //         reason: JSON.stringify(event),
      //         type: typeof event
      //       });
      //     });
      //   return false;
      // }
    },
    enabledReleaseStages,
    releaseStage: import.meta.env.VITE_REACT_APP_ENV,
    appVersion: APP_VERSION,
  });
  return Bugsnag.getPlugin('react').createErrorBoundary(React);
};

export const bugSnagNotifyAPIError = (
  apiName: string,
  requestPayload: object,
  responseErrorMessage: string,
) => {
  if (responseErrorMessage !== 'Network Error') {
    Bugsnag.leaveBreadcrumb(
      `Failed API: ${apiName}`,
      requestPayload,
      BugSnagTypes.ERROR as BreadcrumbType
    );
    Bugsnag.notify(new Error(responseErrorMessage));
  } else {
    // remove the 'Failed Api' word form the log message if network error occur 
    Bugsnag.leaveBreadcrumb(
      apiName,
      requestPayload,
      BugSnagTypes.ERROR as BreadcrumbType
    );
  }
};
